import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Experiencia from "../../../components/Experiencia";
import Educacion from "../../../components/Educacion";
import Habilidades from "../../../components/Habilidades";
import LogrosCert from "../../../components/LogrosCertificaciones";
import Idiomas from "../../../components/Idiomas";
import download from "downloadjs";
import Loader from "../../../components/Loading/loading";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toast from "react-hot-toast";

import userProfile from "../../../static/images/user_default.png";
import icon_prfile from "../../../static/images/icon-prfile.png";
import iconshare from "../../../static/images/icon-share.svg";
import icondownload from "../../../static/images/icon-download.svg";
import editbutton from "../../../static/images/edit-button.svg";
import portada from "../../../static/images/banner_default.png";

import $ from "jquery";
import RecommendationsList from "../../../components/Recomendaciones/RecommendationsList";
import useOnceEffect from "../../../Hooks/useOnceEffect";
import Contrato from "../../../components/Contrato";
import AreasInteres from "../../../components/AreasInteres";
import { Url } from "../../../utils/Url/Url";
import Insignias from "./Insignias";
import CreateProfileModal from "./CreateProfileModal";
function Perfil({ reload }) {
  const [applicantData, setApplicantData] = useState("");
  const [loading, setLoading] = useState(true);
  const [updateProfileModal, setupdateProfile] = useState(false);
  const [departmentList, setdepartmentList] = useState([]);
  const [municipalitiesList, setMunicipalities] = useState([]);
  const [areaList, setareaList] = useState([]);
  const [user, setPhotoProfile] = useState(userProfile);
  const [userP, setPortadaProfile] = useState(portada);
  const [show, setShow] = useState(false);
  const [genders, setGenders] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  ///Metodo para mostrar y ocultar modal de creacion de perfil
  const location = useLocation();
  const [actual, setActual] = useState("");
  let history = useHistory();
  window.onpopstate = function (event) {
    if (!updateProfileModal) {
      alert("Debes completar el formulario de registro");
      history.push("/user/Perfil");
    }
  };

  useOnceEffect(() => {
    setActual(document.location);

    axios
      .get("gender")
      .then((res) => setGenders(res.data))
      .catch(() => console.error("No se pudieron retraer los generos"));
  }, []);

  useEffect(() => {
    let abortController = new AbortController();
    const getApplicant = () => {
      let userId = localStorage.getItem("userId");

      if (location.state !== undefined) {
        axios
          .get("access/applicant/" + location.state.userid)
          .then((result) => {
            if (result.status === 200) {
              if (!result.data.applicantProfile.aboutme) {
                toast.error("Perfil no valido");
                setLoading(true);
              } else {
                setApplicantData(result.data.applicantProfile);

                setupdateProfile(true);
                setLoading(false);
                showProfilePic(
                  result.data.applicantProfile.image,
                  result.data.applicantProfile.coverImage
                );
              }
              // UploadPictures(result.data.applicantProfileId);
            } else if (result.status === 400) {
              toast.error(
                result.errors[0].field + " " + result.errors[0].defaultMessage
              );
            } else toast.error(result.message);
          });
      } else if (userId !== null) {
        axios
          .get("access/applicant/" + userId)
          .then((result) => {
            if (result.status === 200) {
              if (!result.data.applicantProfile.aboutme) {
                // callmodal(true);
                handleShow();
                setLoading(false);
              } else {
                setApplicantData(result.data.applicantProfile);
                getMunicipalities(
                  result.data.applicantProfile.department.departmentId
                );
                setupdateProfile(true);
                setLoading(false);
                showProfilePic(
                  result.data.applicantProfile.image,
                  result.data.applicantProfile.coverImage
                );
              }
              // UploadPictures(result.data.applicantProfileId);
            } else if (result.status == 400) {
              toast.error(
                result.errors[0].field + " " + result.errors[0].defaultMessage
              );
            } else toast.error(result.message);
          })
          .catch((e) => {
            if (e?.response?.status === 400) {
              //callmodal(true);
              handleShow();
              setLoading(false);
            }
          });
      }
    };

    getApplicant();

    return () => {
      abortController.abort();
    };
  }, [location.state]);

  useEffect(() => {
    const getDepartamento = async () => {
      await axios.get("department-list").then((result) => {
        if (result.status === 200) {
          setdepartmentList(result.data);
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      });
    };

    const getArea = () => {
      axios.get("access/areas").then((result) => {
        if (result.status === 200) {
          setareaList(result.data);
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      });
    };
    getDepartamento();
    getArea();
  }, []);

  const getMunicipalities = async (id) => {
    await axios.get("access/municipalities?department=" + id).then((result) => {
      if (result.status === 200) {
        setMunicipalities(result.data);
      } else if (result.status === 400) {
        toast.error(
          result.errors[0].field + " " + result.errors[0].defaultMessage
        );
      } else toast.error(result.message);
    });
  };

  const onChangeSelect = (e, field, values, setValues) => {
    getMunicipalities(e.target.value);

    // call formik onChange method
    field.onChange(e);
  };

  //Función guardar perfil
  function postProfile(values) {
    var targetTime = new Date(values.birthdate);
    var timeZoneFromDB = +6.0;
    var tzDifference = timeZoneFromDB * 60 + targetTime.getTimezoneOffset();
    var offsetTime = new Date(targetTime.getTime() + tzDifference * 60 * 1000);

    let profile = {
      ...values,
      birthdate: offsetTime,
      municipality: values.municipalityId,
      areaId: null,
      bannerImage: null,
      fotoProfile: null,
      applicantId: 0,
    };

    axios
      .post("access/create-applicantprofile", profile)
      .then((result) => {
        //$("#crear-perfil-modal").modal("hide");
        handleClose();
        toast.success("Se ha creado su perfil exitosamente", {
          duration: 6000,
        });
        //location.reload();
      })
      .catch(function (error) {
        if (error.response.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
        }
        if (error.response.status === 400) {
          toast.error(error.response.data.message);
        }
        //$("#crear-perfil-modal").modal("hide");
        handleClose();
      })
      .finally(() => window.location.reload());
  }

  function updateProfile(values) {
    var targetTime = new Date(values.birthdate);
    var timeZoneFromDB = +6.0;
    var tzDifference = timeZoneFromDB * 60 + targetTime.getTimezoneOffset();
    var offsetTime = new Date(targetTime.getTime() + tzDifference * 60 * 1000);

    let profile = {
      ...values,
      birthdate: offsetTime,
      bannerImage: null,
      fotoProfile: null,
      departmentId: values.departmentId?.departmentId ?? values.departmentId,
      municipality: values.municipalityId,
      applicantId: applicantData.applicantProfileId,
      areaId: null,
    };

    applicantData.aboutme = values.aboutme;
    return axios
      .post("access/update-applicantprofile/", profile)
      .then((result) => {
        $("#actualizar-perfil-modal").modal("hide");
        toast.success("Se ha actualizado su perfil exitosamente", {
          duration: 6000,
        });
        window.location.reload();
        return true;
      })
      .catch(function (error) {
        if (error?.response?.status === 400) {
          $("#actualizar-perfil-modal").modal("hide");
          toast.error(error?.response?.data.message);
        } else {
          $("#actualizar-perfil-modal").modal("hide");
          toast.error(error?.response?.data?.message);
        }
      });
  }

  function showProfilePic(profile, banner) {
    const pp = document.getElementById("profilePic");
    if (profile !== null) {
      pp.src = profile;
      setPhotoProfile(pp.src);
    }

    const bp = document.getElementById("bannerPic");
    if (banner !== undefined) {
      bp.src = banner;
    }
  }

  function ActualizarPortada() {
    let banner = document.getElementById("bannerImageUpdate");

    let formData = new FormData();

    formData.append("bannerImage", banner.files[0]);

    function refresh() {
      location.reload();
    }

    axios
      .post(
        "access/create-photoprofile/" + applicantData.applicantProfileId,
        formData
      )
      .then((result) => {
        const objectURL = URL.createObjectURL(banner.files[0]);
        setPortadaProfile(objectURL);

        $("#actualizar-portada-modal").modal("hide");
        refresh();
        toast.success("Se ha actualizado la portada exitosamente", {
          duration: 6000,
        });
      })
      .catch(function (error) {
        if (error?.response?.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
          $("#actualizar-portada-modal").modal("hide");
        }
        if (error?.response?.status === 400) {
          toast.error(error?.response?.data?.message);
          $("#actualizar-portada-modal").modal("hide");
        }
      });
  }

  function ActualizarPerfil() {
    let banner = document.getElementById("profileImageUpdate");

    let formData = new FormData();

    formData.append("profileImage", banner.files[0]);

    axios
      .post(
        "access/create-photoprofile/" + applicantData.applicantProfileId,
        formData
      )
      .then(() => {
        $("#actualizar-foto-perfil-modal").modal("hide");
        reload();
        toast.success("Se ha actualizado su foto de perfil exitosamente", {
          duration: 3000,
        });
        const objectURL = URL.createObjectURL(banner.files[0]);
        setPhotoProfile(objectURL);
      })
      .catch(function (error) {
        if (error?.response?.status === 403) {
          toast.error(
            "Su usuario no esta autorizado para realizar esta accion, para mayor informacion contactar al administrador"
          );
          $("#actualizar-foto-perfil-modal").modal("hide");
        }
        if (error?.response?.status === 400) {
          toast.error(error.response.data.message);
          $("#actualizar-foto-perfil-modal").modal("hide");
        }
      });
  }

  const Validaciones = Yup.object().shape({
    names: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    lastnames: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    aboutme: Yup.string()
      .required("No puede estar vacio")
      .max(900, "No puede tener mas de 900 caracteres"),
    profession: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(60, "No puede tener mas de 60 caracteres"),
    cedula: Yup.string()
      .required("No puede estar vacio")
      .notOneOf(["-"], "No puede contener el carácter '-'")
      .min(14, "No puede tener menos de 14 caracteres")
      .max(14, "No puede tener mas de 14 caracteres"),
  });

  const ppCss = {
    maxWidth: "233px",
    maxHeight: "233px",
    width: "100%",
    height: "100%",
    borderRadius: "10px",
  };

  const ppBanner = {
    width: "100%",
    height: "100%",
  };

  function DescargarCV(applicant_id, name, lastname) {
    axios
      .get("access/pdf-cv/" + applicant_id, {
        responseType: "blob", // had to add this one here
      })
      .then((result) => {
        if (result.status === 200) {
          const content = result.headers["content-type"];
          download(result.data, "CV_" + name + " " + lastname, content);
          toast.success("Descargando", {
            duration: 4000,
          });
        } else if (result.status === 400) {
          toast.error(
            result.errors[0].field + " " + result.errors[0].defaultMessage
          );
        } else toast.error(result.message);
      })
      .catch((e) => {
        if (!e.status) {
          toast.error(
            "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
            { duration: 5000 }
          );
        }
      });
  }

  return (
    <Fragment>
      <div className="profile">
        {loading ? <Loader type="full"></Loader> : ""}

        {/* Perfil Header */}
        <div className="profile__header">
          <div className="profile__header-container">
            <div className="profile__cover-photo ">
              <img
                id="bannerPic"
                src={
                  applicantData.coverImage !== null
                    ? applicantData.coverImage
                    : portada
                }
                alt="cover"
                style={ppBanner}
              />
              <a
                href="#/"
                className="btn btn--white"
                id="Editportada"
                data-bs-toggle="modal"
                data-bs-target="#actualizar-portada-modal"
                data-title="Portada"
              >
                Editar Portada
              </a>
            </div>
            <div className="profile__header-content">
              <div className="profile__row">
                <div className="profile__info">
                  <div className="profile__photo">
                    <img id="profilePic" src={user} alt="" style={ppCss}></img>
                    <a
                      href="#/"
                      className="link"
                      data-bs-toggle="modal"
                      data-bs-target="#actualizar-foto-perfil-modal"
                      data-title="Perfil"
                    >
                      <img src={icon_prfile} alt="cover"></img>
                    </a>
                  </div>
                  <div className="profile__details">
                    <h1 className="profile__name">
                      {applicantData.names} {applicantData.lastnames}
                    </h1>
                    <div className="profile__position">
                      {applicantData.profession}
                    </div>
                    <div className="profile__list">
                      <ul>
                        <li>
                          <span>Fecha de Nacimiento: </span>
                          {applicantData.birthdate}
                        </li>
                        <li>
                          <span>Género: </span>
                          {applicantData.genderId
                            ? applicantData.genderId.description
                            : ""}
                        </li>
                        <li>
                          <span>Ubicación Actual: </span>
                          {applicantData.department
                            ? applicantData.department.name
                            : ""}
                        </li>

                        {applicantData?.address && (
                          <li>
                            <span>Dirección: </span>
                            {applicantData?.address}
                          </li>
                        )}
                      </ul>
                    </div>
                    <div className="icon-tools">
                      <div className="icon-tools-wrapper">
                        <a
                          href="#/"
                          className="icon-tools__share"
                          onClick={() => {
                            let host = window.location.hostname;
                            //in the case host having a port, include it in the url
                            if (window.location.port) {
                              host = host + ":" + window.location.port;
                            }
                            // Asegurarse de que el protocolo sea https
                            let protocol =
                              window.location.protocol === "https:"
                                ? "https"
                                : "http";

                            let finalUrl = `${protocol}://${host}/compartir/candidato/${applicantData.applicantProfileId}`;
                            let Title = `Visita el perfil de ${applicantData.names} ${applicantData.lastnames} en Krezco, la red social de desarrollo profesional`;
                            navigator.share({
                              title: Title,
                              url: finalUrl,
                            });
                          }}
                        >
                          <img src={iconshare} alt="Share"></img>
                        </a>
                        <a href="#/" className="icon-tools__download">
                          <img
                            src={icondownload}
                            alt="Download"
                            onClick={() => {
                              DescargarCV(
                                applicantData.applicantProfileId,
                                applicantData.names,
                                applicantData.lastnames
                              );
                            }}
                          ></img>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="profile__social">
                  <ul className="profile__social__links social-links">
                    {applicantData.linkTwitter != undefined ? (
                      <li>
                        <a href={Url(applicantData.linkTwitter)}>
                          <i className="fab fa-twitter-square"></i>
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                    {applicantData.linkFacebook != undefined ? (
                      <li>
                        <a href={Url(applicantData.linkFacebook)}>
                          <i className="fab fa-facebook-square"></i>
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                    {applicantData.linkInstagram != undefined ? (
                      <li>
                        <a href={Url(applicantData.linkInstagram)}>
                          <i className="fab fa-instagram-square"></i>
                        </a>
                      </li>
                    ) : (
                      ""
                    )}
                  </ul>
                </div>
              </div>
              <div className="profile__row">
                <Insignias />

                <div className="profile__about">
                  <button
                    href="#"
                    className="edit-btn"
                    data-bs-toggle="modal"
                    data-bs-target="#actualizar-perfil-modal"
                    data-title="Experiencia"
                  >
                    <img src={editbutton} alt="Agregar Experiencia" />
                  </button>
                  <div className="row-title">Acerca de mí</div>
                  <p>{applicantData.aboutme}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Perfil Body */}
        <section className="body-profile">
          <div className="container">
            <div className="row">
              <div className="col-7 " id="panel-central-perfil">
                <Experiencia
                  data={applicantData.applicantProfileId}
                  edit={true}
                />

                <Educacion
                  data={applicantData.applicantProfileId}
                  edit={true}
                />

                <Habilidades
                  data={applicantData.applicantProfileId}
                  edit={true}
                />

                <Idiomas data={applicantData.applicantProfileId} edit={true} />

                <LogrosCert
                  data={applicantData.applicantProfileId}
                  edit={true}
                />

                <RecommendationsList />
              </div>
              <div className="col-12 col-sm-5">
                <Contrato data={applicantData.applicantProfileId} edit={true} />

                {applicantData && (
                  <AreasInteres
                    edit={true}
                    applicantProfileId={applicantData.applicantProfileId}
                  />
                )}
              </div>
            </div>
          </div>
        </section>

        {/* Modificar perfil */}
        {updateProfileModal && (
          <div
            id="actualizar-perfil-modal"
            className="kr-modal modal fade"
            tabIndex="-1"
            role="dialog"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <div className="modal-title"></div>

                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="form form--white ">
                    <Formik
                      initialValues={{
                        names: applicantData.names,
                        lastnames: applicantData.lastnames,
                        birthdate: applicantData.birthdate,
                        aboutme: applicantData.aboutme,
                        profession: applicantData.profession,
                        departmentId:
                          applicantData.department?.departmentId ?? "",
                        municipalityId:
                          applicantData.municipalityId?.municipalityId ?? "",
                        genderId: applicantData.genderId
                          ? applicantData.genderId.genderId
                          : "",
                        address: applicantData?.address ?? "",
                        cedula: applicantData?.cedula,
                      }}
                      onSubmit={async (values, { setSubmitting }) => {
                        setSubmitting(true);
                        await updateProfile(values);
                        setSubmitting(false);
                      }}
                      validationSchema={Validaciones}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        isSubmitting,
                        setValues,
                      }) => {
                        return (
                          <Form>
                            <div className="div__wrapper">
                              <div className="form__title text-center">
                                Actualizar Perfil
                              </div>
                              <div className="form__description text-center">
                                Formulario de actualización de datos.
                              </div>

                              <div className="form__row">
                                <div className="col-sm-12 ">
                                  <label htmlFor="names">Nombres</label>
                                  <Field
                                    type="text"
                                    name="names"
                                    id="names"
                                    required
                                  ></Field>
                                  {errors.names && touched.names && (
                                    <span className="form__validation form__validation--error">
                                      {errors.names}
                                    </span>
                                  )}
                                </div>
                                <div className="col-sm-12 mt-3">
                                  <label htmlFor="lastnames">Apellidos</label>
                                  <Field
                                    type="text"
                                    name="lastnames"
                                    id="lastnames"
                                    required
                                  ></Field>
                                  {errors.lastnames && touched.lastnames && (
                                    <span className="form__validation form__validation--error">
                                      {errors.lastnames}
                                    </span>
                                  )}
                                </div>
                                <div className="col-sm-12 mt-3">
                                  <label htmlFor="profession">Formación</label>
                                  <Field
                                    type="text"
                                    name="profession"
                                    id="profession"
                                    required
                                  ></Field>
                                  {errors.profession && touched.profession && (
                                    <span className="form__validation form__validation--error">
                                      {errors.profession}
                                    </span>
                                  )}
                                </div>
                                <div className="col-sm-12 mt-3">
                                  <label htmlFor="birthdate">
                                    Fecha Nacimiento
                                  </label>
                                  <Field
                                    type="date"
                                    name="birthdate"
                                    id="birthdate"
                                    className="form-control"
                                    required
                                  ></Field>
                                  {errors.birthdate && touched.birthdate && (
                                    <span className="form__validation form__validation--error">
                                      {errors.birthdate}
                                    </span>
                                  )}
                                </div>

                                <div className="col-sm-12 mt-3">
                                  <label> Número de cédula</label>
                                  <Field
                                    type="text"
                                    name="cedula"
                                    placeholder="0000000000000M"
                                  />
                                  {errors.cedula && touched.cedula && (
                                    <span className="form__validation form__validation--error">
                                      {errors.cedula}
                                    </span>
                                  )}
                                </div>
                              </div>

                              <div className="col-12 mb-3">
                                <label>Dirección</label>
                                <Field type="text" name="address" />
                              </div>

                              <div className="form__row">
                                <label htmlFor="gender">Departamento</label>
                                <Field
                                  name="departmentId"
                                  id="departmentId"
                                  required
                                >
                                  {({ field }) => (
                                    <select
                                      {...field}
                                      onChange={(e) =>
                                        onChangeSelect(
                                          e,
                                          field,
                                          values,
                                          setValues
                                        )
                                      }
                                      selected
                                    >
                                      <option
                                        value={
                                          applicantData.departmentId
                                            ?.deparmentId
                                        }
                                      >
                                        {applicantData.departmentId?.name}{" "}
                                      </option>
                                      {departmentList &&
                                        departmentList.map((item, index) => {
                                          return (
                                            <option
                                              key={index}
                                              value={item.departmentId}
                                            >
                                              {item.name}
                                            </option>
                                          );
                                        })}
                                    </select>
                                  )}
                                </Field>
                                {errors.departmens && touched.departmens && (
                                  <span className="form__validation form__validation--error">
                                    {errors.departmens}
                                  </span>
                                )}
                              </div>
                              <div className="form__row">
                                <label htmlFor="municipalityId">
                                  Municipio
                                </label>
                                <Field
                                  as="select"
                                  type="text"
                                  name="municipalityId"
                                  id="municipalityId"
                                  required
                                >
                                  <option
                                    value={values.municipalityId.municipalityId}
                                    selected
                                  >
                                    {values.municipalityId.name}
                                  </option>
                                  {municipalitiesList.map((item, index) => {
                                    return (
                                      <option
                                        key={index}
                                        value={item.municipalityId}
                                      >
                                        {item.name}
                                      </option>
                                    );
                                  })}
                                </Field>
                                {errors.municipalities &&
                                  touched.municipalities && (
                                    <span className="form__validation form__validation--error">
                                      {errors.municipalities}
                                    </span>
                                  )}
                              </div>
                              <div className="form__row">
                                <label htmlFor="gender">Género</label>
                                <Field
                                  as="select"
                                  name="genderId"
                                  id="genderId"
                                  required
                                >
                                  <option value="" disabled hidden>
                                    Elija un género
                                  </option>

                                  {genders.map((elm, i) => (
                                    <option key={i} value={elm.genderId}>
                                      {elm.description}
                                    </option>
                                  ))}
                                </Field>
                                {errors.genders && touched.genders && (
                                  <span className="form__validation form__validation--error">
                                    {errors.genders}
                                  </span>
                                )}
                              </div>
                              <div className="form__row">
                                <label htmlFor="aboutme">Acerca de mi</label>
                                <Field
                                  as="textarea"
                                  type="text"
                                  name="aboutme"
                                  id="aboutme"
                                  required
                                ></Field>
                                {errors.aboutme && touched.aboutme && (
                                  <span className="form__validation form__validation--error">
                                    {errors.aboutme}
                                  </span>
                                )}
                              </div>
                              <div className="form__row">
                                <button
                                  disabled={isSubmitting}
                                  type="submit"
                                  className="btn btn--gradient btn__icon btn__icon--door"
                                >
                                  Actualizar
                                </button>
                              </div>
                            </div>
                          </Form>
                        );
                      }}
                    </Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Actualizar portada */}
        <div
          id="actualizar-portada-modal"
          className="kr-modal modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title"></div>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="form form--white ">
                  <div className="div__wrapper">
                    <div className="form__description text-center">
                      Seleccione una imagen
                    </div>
                    <div className="form__row">
                      <div className="col-sm-12 col-md-8">
                        <label htmlFor="bannerImageUpdate">Banner</label>
                        <input
                          id="bannerImageUpdate"
                          type="file"
                          required
                        ></input>
                      </div>
                    </div>
                    <div className="form__row">
                      <button
                        onClick={ActualizarPortada}
                        className="btn btn--gradient btn__icon btn__icon--door"
                      >
                        Actualizar Portada
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Actualizar foto perfil */}
        <div
          id="actualizar-foto-perfil-modal"
          className="kr-modal modal fade"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <div className="modal-title"></div>

                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="form form--white ">
                  <div className="div__wrapper">
                    <div className="form__description text-center">
                      Seleccione una imagen
                    </div>
                    <div className="col-sm-12 col-md-6">
                      <label htmlFor="name">Imagen Perfil</label>
                      <div className="file">
                        <i className="fas fa-images"></i> Elegir archivo
                        <input type="file" id="profileImageUpdate" />
                      </div>
                      <small className="green">Archivo Seleccionado</small>
                    </div>
                    {/* <div className="form__row">
                        <div className="col-sm-12 col-md-8">
                          <input
                            id="profileImageUpdate"
                            type="file"
                            required
                          ></input>
                        </div>
                      </div> */}
                    <div className="form__row">
                      <button
                        onClick={ActualizarPerfil}
                        className="btn btn--gradient btn__icon btn__icon--door"
                      >
                        Subir Perfil
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Crear perfil */}
      <CreateProfileModal
        {...{
          show,
          handleClose,
          postProfile,
          Validaciones,
          genders,
          onChangeSelect,
          departmentList,
          municipalitiesList,
        }}
      />

      {/* Editar pefil */}
      <div
        id="crear-perfil-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div className="modal-body">
              <div className="form form--white ">
                <Formik
                  initialValues={{
                    names: "",
                    lastnames: "",
                    birthdate: "1989-01-02",
                    genderId: "",
                    aboutme: "",
                    profession: "",
                    areaId: 0,
                    municipalityId: "",
                    deparmentId: "",
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    postProfile(values);
                    setSubmitting(false);
                  }}
                  validationSchema={Validaciones}
                >
                  {({ errors, touched, isSubmitting, values, setValues }) => (
                    <Form>
                      <div className="div__wrapper">
                        <div className="form__title text-center">
                          Crear Perfil
                        </div>
                        <div className="form__row">
                          <div className="col-sm-12 ">
                            <label htmlFor="names">Nombres</label>
                            <Field
                              type="text"
                              name="names"
                              id="names"
                              required
                            ></Field>
                            {errors.names && touched.names && (
                              <span className="form__validation form__validation--error">
                                {errors.names}
                              </span>
                            )}
                          </div>
                          <div className="col-sm-12 mt-3">
                            <label htmlFor="lastnames">Apellidos</label>
                            <Field
                              type="text"
                              name="lastnames"
                              id="lastnames"
                              required
                            ></Field>
                            {errors.lastnames && touched.lastnames && (
                              <span className="form__validation form__validation--error">
                                {errors.lastnames}
                              </span>
                            )}
                          </div>
                          <div className="form__row">
                            <label htmlFor="gender">Género</label>
                            <Field
                              as="select"
                              name="genderId"
                              id="genderId"
                              required
                            >
                              <option value="" disabled hidden>
                                Elija un género
                              </option>

                              {genders.map((elm, i) => (
                                <option key={i} value={elm.genderId}>
                                  {elm.description}
                                </option>
                              ))}
                            </Field>
                            {errors.genderId && touched.genderId && (
                              <span className="form__validation form__validation--error">
                                {errors.genderId}
                              </span>
                            )}
                          </div>
                          <div className="form__row row">
                            <div className="col-sm-12 col-md-6">
                              <label
                                htmlFor="birthdate"
                                style={{ marginBottom: "0.75rem !important" }}
                              >
                                Fecha de Nacimiento
                              </label>
                              <Field
                                type="date"
                                name="birthdate"
                                id="birthdate"
                                className="form-control"
                                required
                              ></Field>
                              {errors.birthdate && touched.birthdate && (
                                <span className="form__validation form__validation--error">
                                  {errors.birthdate}
                                </span>
                              )}
                            </div>

                            <div className="col-12">
                              <label>Dirección</label>
                              <Field type="text" name="address" />
                            </div>

                            <div className="col-sm-12 col-md-6">
                              <label htmlFor="departmentId">Departamento</label>
                              <Field
                                // as="select"
                                // type="text"
                                name="departmentId"
                                id="departmentId"
                                required
                                // value = {values.departmentId}
                                // onChange = {(e)=>refreshMunicipalities(e.target.value)}
                              >
                                {({ field }) => (
                                  <select
                                    {...field}
                                    onChange={(e) =>
                                      onChangeSelect(
                                        e,
                                        field,
                                        values,
                                        setValues
                                      )
                                    }
                                    selected
                                  >
                                    <option value="">
                                      {" "}
                                      Seleccione un departamento{" "}
                                    </option>
                                    {departmentList &&
                                      departmentList.map((item, index) => {
                                        return (
                                          <option
                                            key={index}
                                            value={item.departmentId}
                                          >
                                            {item.name}
                                          </option>
                                        );
                                      })}
                                  </select>
                                )}
                              </Field>
                              <span className="form__validation"></span>
                            </div>
                            <div className="form__row">
                              <label htmlFor="municipalityId">Municipio</label>
                              <Field
                                as="select"
                                type="text"
                                name="municipalityId"
                                id="municipalityId"
                                required
                              >
                                <option value="" selected>
                                  Selecciona un municipio
                                </option>
                                {municipalitiesList.map((item, index) => {
                                  return (
                                    <option
                                      key={index}
                                      value={item.municipalityId}
                                    >
                                      {item.name}
                                    </option>
                                  );
                                })}
                              </Field>
                              {errors.municipalities &&
                                touched.municipalities && (
                                  <span className="form__validation form__validation--error">
                                    {errors.municipalities}
                                  </span>
                                )}
                            </div>
                          </div>
                          <div className="col-sm-12 ">
                            <label htmlFor="profession">Formación</label>
                            <Field
                              type="text"
                              name="profession"
                              id="profession"
                              required
                            ></Field>
                            {errors.profession && touched.profession && (
                              <span className="form__validation form__validation--error">
                                {errors.profession}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="form__row">
                          <label htmlFor="aboutme">Acerca de mi</label>
                          <Field
                            as="textarea"
                            type="text"
                            name="aboutme"
                            id="aboutme"
                            required
                          ></Field>
                          {errors.aboutme && touched.aboutme && (
                            <span className="form__validation form__validation--error">
                              {errors.aboutme}
                            </span>
                          )}
                        </div>
                        <div className="form__row">
                          <label htmlFor="area">Area de Interés</label>
                          <Field as="select" name="areaId" id="areaId" required>
                            <option hidden selected>
                              Seleccione un area
                            </option>
                            {areaList.map((item) => {
                              return (
                                <option key={item.areaId} value={item.areaId}>
                                  {item.nombre}
                                </option>
                              );
                            })}
                          </Field>
                          {errors.areaId && touched.areaId && (
                            <span className="form__validation form__validation--error">
                              {errors.areaId}
                            </span>
                          )}
                        </div>
                        <div className="form__row">
                          <button
                            type="submit"
                            className="btn btn--gradient btn__icon btn__icon--door"
                          >
                            Guardar
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export { Insignias };

export default Perfil;
